import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, actionLabel, actionPath, color = 'primary' }) => {
  const navigate = useNavigate();

  const colorClasses = {
    primary: 'bg-primary/10 text-primary border-primary/20',
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    error: 'bg-error/10 text-error border-error/20'
  };

  const handleAction = () => {
    if (actionPath) {
      navigate(actionPath);
    }
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-smooth border border-border">
      <div className={`${colorClasses?.[color]} w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg flex items-center justify-center mb-3 md:mb-4 border`}>
        <Icon name={icon} size={24} className="md:w-7 md:h-7 lg:w-8 lg:h-8" />
      </div>
      <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-2">{title}</h3>
      <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 line-clamp-2">{description}</p>
      <Button 
        variant="outline" 
        onClick={handleAction}
        iconName="ArrowRight"
        iconPosition="right"
        fullWidth
        className="text-sm md:text-base"
      >
        {actionLabel}
      </Button>
    </div>
  );
};

export default QuickActionCard;